import React from 'react';
import { useLanguage } from '../context/LanguageContext';

const PortfolioCTA = () => {
  const { t } = useLanguage();

  return (
    <section
      className="relative py-24 md:py-32 border-t border-b overflow-hidden"
      style={{
        backgroundColor: '#111C2E',
        borderColor: 'rgba(212, 175, 55, 0.18)',
      }}
    >
      <div className="max-w-6xl mx-auto px-6 lg:px-10 grid grid-cols-1 md:grid-cols-[60%_38%] md:gap-x-[2%] gap-y-16 items-center">
        {/* Coluna esquerda — texto */}
        <div className="text-center md:text-left">
          <span className="dash-title divider-dash uppercase inline-block mb-6">
            {t.portfolioCta.eyebrow}
          </span>

          <h2 className="light-text font-semibold text-[26px] md:text-[38px] mb-6 max-w-md md:max-w-lg mx-auto md:mx-0">
            {t.portfolioCta.headline}
          </h2>

          <p className="text-[#C9CDD9] text-sm md:text-base font-light leading-relaxed mb-10 max-w-md mx-auto md:mx-0">
            {t.portfolioCta.body}
          </p>

          <a
            href="https://www.pezente.com/portfolio/"
            target="_blank"
            rel="noopener noreferrer"
            className="group inline-flex items-center gap-2 text-xs md:text-sm font-medium uppercase"
            style={{ color: '#D4AF37', letterSpacing: '0.18em' }}
          >
            <span
              className="pb-[3px] border-b"
              style={{ borderColor: 'rgba(212, 175, 55, 0.4)' }}
            >
              {t.portfolioCta.cta}
            </span>
            <span
              className="inline-block transition-transform duration-300 ease-out group-hover:translate-x-1.5"
              aria-hidden="true"
            >
              →
            </span>
          </a>
        </div>

        {/* Coluna direita — dashboard */}
        <div className="flex flex-col items-center md:items-start">
          <div className="relative w-full max-w-[240px] md:max-w-none">
            {/* glow dourado suave atrás da imagem */}
            <div
              className="absolute inset-0 -z-10 blur-3xl opacity-40"
              style={{
                background:
                  'radial-gradient(ellipse 65% 65% at center, rgba(212,175,55,0.35) 0%, rgba(212,175,55,0) 70%)',
              }}
              aria-hidden="true"
            />
            <img
              src="/entra-id-dashboard.png"
              alt={t.portfolioCta.dashboardAlt}
              className="w-full h-auto select-none"
              style={{
                WebkitMaskImage:
                  'radial-gradient(ellipse 92% 92% at center, black 82%, transparent 100%)',
                maskImage:
                  'radial-gradient(ellipse 92% 92% at center, black 82%, transparent 100%)',
              }}
            />
          </div>

          <span
            className="mt-5 text-[11px] md:text-xs italic inline-block text-center md:text-left max-w-[240px] md:max-w-none"
            style={{ color: 'rgba(201, 205, 217, 0.55)', letterSpacing: '0.02em' }}
          >
            {t.portfolioCta.dashboardLabel}
          </span>
        </div>
      </div>
    </section>
  );
};

export default PortfolioCTA;
